export default "__VITE_ASSET__3qnNrRL5__"